import Enum from "../../../../enums/Enum";

const EnumPayAndClaimStatus = new Enum({
    PENDING: {name: "Pending"},
    COMPLETED: {name: "Complete"}
});

export default EnumPayAndClaimStatus;
